var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 512,
    viewBox: "0 0 320 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1526_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208 48C208 74.5 186.5 96 160 96C133.5 96 112 74.5 112 48C112 21.5 133.5 0 160 0C186.5 0 208 21.5 208 48ZM152 352V480C152 497.7 137.7 512 120 512C102.3 512 87.9996 497.7 87.9996 480V256.9L59.3996 304.5C50.2996 319.6 30.5996 324.5 15.4996 315.4C0.399614 306.3 -4.50039 286.6 4.59962 271.5L62.8996 174.5C80.2996 145.6 111.5 127.9 145.2 127.9H174.9C208.6 127.9 239.8 145.6 257.2 174.5L315.5 271.5C324.6 286.6 319.7 306.3 304.6 315.4C289.5 324.5 269.8 319.6 260.7 304.5L232 256.9V480C232 497.7 217.7 512 200 512C182.3 512 168 497.7 168 480V352H152Z",
    fill: "#101012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1526_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.75682eafcc5201dbe7d23b4aa137bb11.svg";
export { ForwardRef as ReactComponent };